import { AnalyticsBrowser } from '@segment/analytics-next';
const createSegmentClient = () => {
  const initialize = config => {
    AnalyticsBrowser.load({
      writeKey: config.writeKey
    });
  };
  return {
    initialize
  };
};
const segmentClient = createSegmentClient();
export default segmentClient;